import React, { useState, useEffect } from 'react'
import classes from './FileUpload.module.css'
import { db, storage, timeStamp } from '../firebaseConfig'
import { useAuth } from '../Context/AuthContext'
import { CircularProgress } from '@material-ui/core'

function FileUpload() {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const { currentUser } = useAuth();
    const [progress, setProgress] = useState(0)
    const [caption, setCaption] = useState('')
    const uploadFileHandler = (e) => {
        const selected = e.target.files[0];
        if (selected) {
            setFile(selected);

        }
    }
    useEffect(() => {
        setCaption('')
        setProgress(0)
        setFile(null)

    }, [loading])
    async function uploadFile(e) {
        e.preventDefault();
        setLoading(true);
        if (!file || !caption) {
            const form = document.querySelector('form');
            form.reset();
            setLoading(false)
            return alert("Please check all the fields")

        }
        try {

            const storageRef = storage.ref(file.name);
            const imageDatabase = db.collection('images');
            const userDatabase = db.collection('users').doc(currentUser.uid).collection('userImage');
            const name = currentUser.displayName
            // const caption = caption
            storageRef.put(file).on('state_changed', (snap) => {
                let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
                setProgress(percentage);

            }, (err) => {
                alert(err);
            }, async () => {
                const url = await storageRef.getDownloadURL();
                const createdAt = timeStamp();
                const { id } = await imageDatabase.add({ url, createdAt, name, caption });
                console.log(id);
                userDatabase.add({ url, createdAt })
                const form = document.querySelector('form');
                form.reset();
            })

            setCaption('')
            setProgress(0)
            setFile(null)
            setLoading(false);

        }
        catch {
            alert("cant upload file")
        }
        setCaption('')
        setProgress(0)
        setFile(null)
        setLoading(false);

    }
    return (

        <form className={classes.form} >
            { loading && <CircularProgress className={classes.circular} />}
            <div className={classes.caption}>
                <input type="text" placeholder="Caption" onChange={(e) => setCaption(e.target.value)} />
                <input type="file" onChange={uploadFileHandler} />
                <button type="submit" disabled={loading} onClick={uploadFile}>Upload</button>
            </div>
            {loading && <div className={classes.progress} style={{ width: `${progress}%` }}></div>}



        </form >

    )
}

export default FileUpload
